import createVueComponent from '../createVueComponent';

const Linkedin = createVueComponent('LinkedinIcon', [
  [
    'path',
    {
      d:
        'M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6z',
    },
  ],
  ['rect', { x: '2', y: '9', width: '4', height: '12' }],
  ['circle', { cx: '4', cy: '4', r: '2' }],
]);

export default Linkedin;
